import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcFaq(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.352 13.125c-.594 0-1.099.274-1.393.665a.75.75 0 1 1-1.199-.902c.583-.774 1.535-1.263 2.592-1.263 1.7 0 3.177 1.29 3.177 3s-1.477 3-3.177 3a.75.75 0 1 1 0-1.5c.981 0 1.677-.724 1.677-1.5s-.696-1.5-1.677-1.5M16.725 18.65a.9.9 0 0 1 .9.9v.01a.9.9 0 0 1-1.8 0v-.01a.9.9 0 0 1 .9-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.796 11.28c0-4.781 4.21-8.548 9.262-8.548 4.592 0 8.475 3.102 9.157 7.257a.75.75 0 1 1-1.48.243c-.55-3.349-3.734-6-7.677-6-4.35 0-7.762 3.216-7.762 7.049 0 1.226.345 2.38.954 3.387l.174.287-1.133 3.709 3.966-1.23.263.122a8.4 8.4 0 0 0 3.538.773q.51 0 1.003-.058a.75.75 0 1 1 .174 1.49q-.579.068-1.177.068a9.9 9.9 0 0 1-3.903-.793L4.5 20.17c-1.062.33-2.031-.673-1.713-1.716l1.01-3.305a8 8 0 0 1-1-3.868",
    clipRule: "evenodd"
  }));
}
var IcFaq = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFaq));

export { IcFaq as I };
